import { render, staticRenderFns } from "./safeProducts.vue?vue&type=template&id=78b5bf89"
import script from "./safeProducts.vue?vue&type=script&lang=js"
export * from "./safeProducts.vue?vue&type=script&lang=js"
import style0 from "./safeProducts.vue?vue&type=style&index=0&id=78b5bf89&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b5bf89')) {
      api.createRecord('78b5bf89', component.options)
    } else {
      api.reload('78b5bf89', component.options)
    }
    module.hot.accept("./safeProducts.vue?vue&type=template&id=78b5bf89", function () {
      api.rerender('78b5bf89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps/safeProducts.vue"
export default component.exports